import { useEffect, useState } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import { supabase } from './lib/supabase';
import BakimPage from './pages/bakim/page';

function MainContent() {
  const location = useLocation();
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMaintenanceMode = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('maintenance_mode')
          .eq('id', 1)
          .maybeSingle();

        if (!error && data) {
          setMaintenanceMode(data.maintenance_mode === true);
        }
      } catch {
        setMaintenanceMode(false);
      } finally {
        setLoading(false);
      }
    };

    fetchMaintenanceMode();

    const channel = supabase
      .channel('site_settings_maintenance')
      .on(
        'postgres_changes',
        { event: 'UPDATE', schema: 'public', table: 'site_settings', filter: 'id=eq.1' },
        (payload) => {
          if (payload.new && typeof payload.new.maintenance_mode === 'boolean') {
            setMaintenanceMode(payload.new.maintenance_mode);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const isAdminRoute = location.pathname.startsWith('/admin');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <i className="ri-loader-4-line text-4xl text-teal-600 animate-spin"></i>
      </div>
    );
  }

  if (maintenanceMode && !isAdminRoute) {
    return <BakimPage />;
  }

  return <AppRoutes />;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <MainContent />
    </BrowserRouter>
  );
}

export default App;
